import { create } from 'zustand';

export type TReferralConfig = {
  code: string;
  link: string;
};

export type TReferral = {
  name: string;
  totalPoints: number;
  avatar_url: string;
};

export type TReferralStats = {
  referralCount: number;
  referrals: TReferral[];
};

interface IReferralStore {
  referralConfig: TReferralConfig | null;
  setReferralConfig: (config: TReferralConfig) => void;
  referralStats: TReferralStats | null;
  setReferralStats: (stats: TReferralStats) => void;
}

export const useReferralStore = create<IReferralStore>((set) => ({
  referralConfig: null,
  setReferralConfig: (config) => set({ referralConfig: config }),
  referralStats: null,
  setReferralStats: (stats) => set({ referralStats: stats }),
}));
